import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    {
      staticClass: "pa-5 inthemiddle",
      attrs: { width: "340px", height: "240px", elevation: "4" },
    },
    [
      _c(
        VForm,
        { attrs: { method: "POST", action: "/api/login" } },
        [
          _c(VTextField, {
            ref: "focusMe",
            attrs: {
              name: "username",
              label: "Benutzername",
              placeholder: "Benutzername",
              single: "",
              outlined: "",
              required: "",
            },
          }),
          _vm._v(" "),
          _c(VTextField, {
            attrs: {
              name: "password",
              label: "Passwort",
              placeholder: "Password",
              required: "",
              single: "",
              outlined: "",
              type: "password",
            },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "next", type: "hidden" },
            domProps: {
              value: _vm.$route.query.next ? _vm.$route.query.next : "/",
            },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "fail", type: "hidden", value: "/Login" },
          }),
          _vm._v(" "),
          _c(VBtn, { attrs: { type: "submit", color: "primary" } }, [
            _vm._v(" Login "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }